import FavoriteIcon from "@material-ui/icons/Favorite";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import StarIcon from "@material-ui/icons/Star";

export const QUESTION_TYPE_ATTR_SELECT_SCORE = {
  CIRCLE: "circle",
  HEART: "heart",
  STAR: "star",
};

export const QUESTION_TYPE_ATTR_FREE_TEXT = {
  NO_LIMIT: "all",
  ALPHANUMERIC: "alphanumeric",
  NUMERIC: "numeric",
};

export const SELECT_SCORE_COLOR = {
  [QUESTION_TYPE_ATTR_SELECT_SCORE.CIRCLE]: "rgba(66, 189, 244, #alpha)",
  [QUESTION_TYPE_ATTR_SELECT_SCORE.HEART]: "rgba(235, 118, 133, #alpha)",
  [QUESTION_TYPE_ATTR_SELECT_SCORE.STAR]: "rgba(253, 208, 84, #alpha)",
  default: "rgba(196, 196, 196, #alpha)",
};

export const SELECT_SCORE_ICON = {
  [QUESTION_TYPE_ATTR_SELECT_SCORE.CIRCLE]: <FiberManualRecordIcon />,
  [QUESTION_TYPE_ATTR_SELECT_SCORE.HEART]: <FavoriteIcon />,
  [QUESTION_TYPE_ATTR_SELECT_SCORE.STAR]: <StarIcon />,
};

export const MIN_DATE = "1900-01-01T00:00";
export const MAX_DATE = "9999-12-31T23:59";
export const DEFAULT_FORMATED_DATE = "YYYY/MM/DD";

export const DEFAULT_OPTION_PREFECTURE = 'all_provinces';
